import { resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "input-group" }
const _hoisted_2 = ["value"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, "/", -1)
const _hoisted_4 = ["value"]
const _hoisted_5 = {
  key: 0,
  class: "input-group-text"
}
const _hoisted_6 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _directive_mask = _resolveDirective("mask")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      class: "form-control",
      placeholder: "X",
      value: $data.mutableValue.x,
      onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($options.inputX && $options.inputX(...args))),
      ref: "inputX"
    }, null, 40, _hoisted_2), [
      [_directive_mask, '### ###']
    ]),
    _hoisted_3,
    _withDirectives(_createElementVNode("input", {
      class: "form-control",
      placeholder: "Y",
      value: $data.mutableValue.y,
      onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($options.inputY && $options.inputY(...args))),
      ref: "inputY"
    }, null, 40, _hoisted_4), [
      [_directive_mask, '### ###']
    ]),
    ($props.withHeight)
      ? (_openBlock(), _createElementBlock("span", _hoisted_5, "/"))
      : _createCommentVNode("", true),
    ($props.withHeight)
      ? _withDirectives((_openBlock(), _createElementBlock("input", {
          key: 1,
          class: "form-control",
          placeholder: "H",
          value: $data.mutableValue.z,
          onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($options.inputZ && $options.inputZ(...args))),
          ref: "inputZ"
        }, null, 40, _hoisted_6)), [
          [_directive_mask, '####']
        ])
      : _createCommentVNode("", true),
    _createElementVNode("button", {
      type: "button",
      class: "btn btn-outline-secondary",
      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($options.openList && $options.openList(...args)))
    }, [
      _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-list" })
    ]),
    _createElementVNode("button", {
      type: "button",
      class: "btn btn-outline-secondary",
      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($options.paste && $options.paste(...args)))
    }, [
      _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-paste" })
    ])
  ]))
}